import productInfo from './tile-box/product-info';
import productSizeWrapper from './tile-box/product-size-wrapper';

/**
 * @param {Array<Object>} product - product
 * @returns {string} product tile box HTML
 */
export default product => {
    return `
        <div class="tile-box">
            ${productInfo(product)}
            ${productSizeWrapper(product)}
            ${
                product.comparePriceString !== null && product.mainProductGroup !== 3
                    ? `
                    <div class="unit-price-plp">
                        <span>${product.comparePriceString}</span>
                    </div>`
                    : ''
            }
            <div class="product-tile-hover-view">
            </div>
        </div>
    `;
};
